import React, { useState, useEffect } from "react";
import images from "../../../themes/appImage";
import { useDispatch, useSelector } from "react-redux";
import { dummyCreatePostLoad } from "../../../redux/slices/engagementFarming.slice";
import { encouragementGroupListLoad } from "../../../redux/slices/encouragementgroups.slice";
import { dummyUserListLoad } from "../../../redux/slices/createUser.slice";
import { Select } from "antd";

const postTypeHandler = (fileType, text) => {
  if (fileType === "image/jpeg" || fileType === "image/png") {
    return text ? "imageWithText" : "postOnly";
  } else if (fileType === "video/mp4") {
    return text ? "videoWithText" : "videoOnly";
  } else if (fileType === "image/gif") {
    return text ? "textWithGIF" : "gifOnly";
  } else {
    return "textOnly";
  }
};

function CreatePost() {
  const [postText, setPostText] = useState("");
  const [file, setFile] = useState(null);
  const [type, setType] = useState("community");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [pagination, setPagination] = useState({ limit: 500, offset: 0 });
  const uploadFileType = file?.type?.length > 0 ? file.type : undefined;

  const dispatch = useDispatch();

  const groupList = useSelector((state) => {
    return (
      state.EncouragementgroupsReducer?.encouragementGroupListData?.groupList ||
      []
    );
  });

  const dummyUsers = useSelector(
    (state) => state.createUserReducer?.data?.data?.list || [],
  );

  useEffect(() => {
    if (type === "group") {
      dispatch(encouragementGroupListLoad(pagination));
    }
  }, [type, dispatch]);

  useEffect(() => {
    dispatch(dummyUserListLoad(pagination));
  }, [dispatch, pagination]);

  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    setFile(uploadedFile);
  };

  const removeFile = () => {
    setFile(null);
  };

  const handleCreatePost = () => {
    const formData = new FormData();

    formData.append("text", postText);
    formData.append("type", type);

    const postType = postTypeHandler(uploadFileType, postText);
    formData.append("postType", postType);

    if (file) {
      formData.append("file", file);
    }

    if (selectedUser) {
      formData.append("userId", selectedUser);
    }

    if (type === "group") {
      if (!selectedGroup) {
        return;
      }
      formData.append("group", selectedGroup);
    }
    dispatch(dummyCreatePostLoad(formData));
    // dispatch(engagementFarmingListLoad());
  };

  return (
    <div>
      <div>
        <h3 className="text-[23px] ml-14 mt-6">Create Post</h3>
        <div className="mt-2 ml-14">
          <p>Enter post text</p>
          <textarea
            value={postText}
            onChange={(e) => setPostText(e.target.value)}
            placeholder="Write something..."
            className="border p-2 rounded w-[700px] h-[140px] mt-1"
          />
        </div>

        <div className="upload-post-sec ml-5 mt-4">
          <div className="click-to-upload relative">
            {uploadFileType && (
              <div
                onClick={removeFile}
                className="bg-white cursor-pointer p-2 w-5 h-5 absolute -right-3 -top-3 border border-black rounded-full flex justify-center items-center"
              >
                x
              </div>
            )}

            <div className="upload-file new-up-file w-[800px] h-[300px] flex items-center justify-center border rounded bg-gray-50 overflow-hidden">
              {uploadFileType ? (
                uploadFileType === "video/mp4" ? (
                  <video
                    controls
                    className="max-w-full max-h-full object-contain"
                  >
                    <source src={URL.createObjectURL(file)} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    src={URL.createObjectURL(file)}
                    alt="upload"
                    className="max-w-full max-h-full object-contain"
                  />
                )
              ) : (
                <>
                  <div className="upload-center-text text-center">
                    <label htmlFor="fileUpload">
                      <p className="cursor-pointer">
                        <span>
                          <img src={images.upload} alt="upload" />
                        </span>{" "}
                        Click here to upload
                      </p>
                    </label>
                    <input
                      type="file"
                      id="fileUpload"
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                    />
                  </div>
                  <p className="image-disp text-gray-500 text-sm mt-2">
                    File Format: .JPEG, .PNG, .MP4, .GIF
                  </p>
                </>
              )}
            </div>

            {/* Select User input with dropdown icon */}
            <div className="mt-6 mb-4 ml-[1%]">
              <p className="mb-2 text-[18px] font-semibold">Select User:</p>
              <div className="w-[500px]">
                <Select
                  onChange={(val) => {
                    setSelectedUser(val);
                  }}
                  placeholder="Choose a user"
                  value={selectedUser}
                  className="border p-2 rounded w-full appearance-none pr-10 w-[50%]"
                  //  className="w-[100%] "
                  dropdownClassName="Avatar-drop"
                >
                  <option value="">Select a user</option>
                  {dummyUsers?.length > 0 ? (
                    dummyUsers.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.userName}
                      </option>
                    ))
                  ) : (
                    <option disabled>No users found</option>
                  )}
                </Select>
              </div>
            </div>

            {/* Radio buttons for community or group */}
            <div className="mt-6 mb-4 ml-[1%]">
              <p className="mb-2 text-[18px] font-semibold">Select Type:</p>
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="community"
                    checked={type === "community"}
                    onChange={(e) => {
                      setType(e.target.value);
                      setSelectedGroup("");
                    }}
                    className="mr-2"
                  />
                  Community
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="group"
                    checked={type === "group"}
                    onChange={(e) => setType(e.target.value)}
                    className="mr-2"
                  />
                  Group
                </label>
              </div>
            </div>

            {/* {type === "group" && (
              <div className="mt-4 mb-4 ml-14">
                <p className="mb-2 text-[18px] font-semibold">Select Group:</p>
                <select
                  value={selectedGroup}
                  onChange={(e) => setSelectedGroup(e.target.value)}
                  className="border p-2 rounded w-[300px]"
                >
                  <option value="">Select a group</option>
                  {groupList.map((group) => (
                    <option key={group._id} value={group._id}>
                      {group.name} ({group.totalUser} members)
                    </option>
                  ))}
                </select>
              </div>
            )} */}
            {type === "group" && (
              <div className="mt-6 mb-4 ml-[1%]">
                <p className="mb-2 text-[18px] font-semibold">Select Group:</p>

                <div className="w-[500px]">
                  <Select
                    placeholder="Choose a group"
                    value={selectedGroup || undefined}
                    onChange={(val) => setSelectedGroup(val)}
                    className="border p-2 rounded w-full appearance-none pr-10 w-[50%]"
                    dropdownClassName="Avatar-drop"
                  >
                    {groupList?.length > 0 ? (
                      groupList.map((group) => (
                        <Select.Option key={group._id} value={group._id}>
                          {group.name} ({group.totalUser} members)
                        </Select.Option>
                      ))
                    ) : (
                      <Select.Option disabled>No groups found</Select.Option>
                    )}
                  </Select>
                </div>
              </div>
            )}

            <div className="btn-schedule mt-4 ">
              <button
                onClick={handleCreatePost}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
              >
                Create Post
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePost;
